import { render, staticRenderFns } from "./HowToRegister.vue?vue&type=template&id=e1dfc5d6&"
import script from "./HowToRegister.vue?vue&type=script&lang=ts&setup=true&"
export * from "./HowToRegister.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1dfc5d6')) {
      api.createRecord('e1dfc5d6', component.options)
    } else {
      api.reload('e1dfc5d6', component.options)
    }
    module.hot.accept("./HowToRegister.vue?vue&type=template&id=e1dfc5d6&", function () {
      api.rerender('e1dfc5d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/HowToRegister.vue"
export default component.exports